import { createAction } from "redux-actions";
import { LoginConstant } from "./loginConstant";

export const checkLogin = createAction(LoginConstant.CHECK_LOGIN);
